import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CourseHistory, EditableCourseHistory } from '../model/course-history';
import { MatPaginator } from '@angular/material/paginator';
import { Subscription, find, timer } from 'rxjs';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { AccessService } from 'src/app/component/navigation/service/access.service';
import { CourseSection } from 'src/app/model/course-section';
import { CourseType } from 'src/app/model/course-type';
import { TermType } from 'src/app/model/term-type';
import { CourseHistoryService } from '../../../service/course-history.service';
import { Msg } from 'src/app/component/auth/model/user.model';
import { CourseHistorySchoolEnrollments } from '../model/course-history-school-enrollments';
import { Region } from 'src/app/model/region.model';
import { HelperService } from 'src/app/service/helper.service';
import { CountyDataService } from 'src/app/component/common-components/service/county-data.service';
import { MatFormFieldControl } from '@angular/material/form-field';
import { UntypedFormControl, Validators } from '@angular/forms';
import moment from 'moment';

@Component({
    selector: 'app-course-history-table',
    templateUrl: './course-history-table.component.html',
    styleUrls: ['./course-history-table.component.scss']
})
export class CourseHistoryTableComponent implements OnInit {
    @Input() studentId: number;
    @Input('courseHistories') lstCourseHistory: EditableCourseHistory[];

    @Input() editing: boolean;
    @Output() modificationEvent = new EventEmitter<string>();

    @ViewChild(MatPaginator) paginator: MatPaginator;

    displayedColumns: string[] = CourseHistoryColumns.filter((x) => x.key != 'isEdit').map((col) => col.key);
    columnsSchema: any = CourseHistoryColumns.filter((x) => x.key != 'isEdit');
    displayedColumnsEdit: string[] = CourseHistoryColumns.map((col) => col.key);
    columnsSchemaEdit: any = CourseHistoryColumns;

    isSaving: boolean = false;
    editAccess: boolean = true;
    deleteAccess: boolean = true;

    courseSections: CourseSection[] = [];
    courseTypes: CourseType[] = [];
    termTypes: TermType[] = [];

    schoolenrollment: CourseHistorySchoolEnrollments[] = [];
    userRegion: Region;

    schoolYear: string = '';
    startingSchoolYearDate: Date;
    //schoolYear: string[] = ['2020-21', '2021-22', '2022-23'];

    horizontalPosition: MatSnackBarHorizontalPosition = 'center';
    verticalPosition: MatSnackBarVerticalPosition = 'top';

    dataSource = new MatTableDataSource<EditableCourseHistory>();

    ctrSchoolYear = new UntypedFormControl('', []);
    ctrEnrollment = new UntypedFormControl('', []);
    ctrCourseTitle = new UntypedFormControl('', []);
    ctrSubjectAreaName = new UntypedFormControl('', []);
    ctrCourseType = new UntypedFormControl('', [Validators.required]);
    ctrTermType = new UntypedFormControl('', []);
    ctrDaysCompleted = new UntypedFormControl('', []);
    ctrGradetoDate = new UntypedFormControl('', []);
    ctrCreditsGranted = new UntypedFormControl('', []);
    termType = new UntypedFormControl('', []);

    constructor(
        public accessService: AccessService,
        public courseHistoryService: CourseHistoryService,
        private msgBar: MatSnackBar,
        private helperService: HelperService
    ) {}

    ngOnInit(): void {
        this.accessService.getCourseSection().subscribe((x) => {
            this.courseSections = x;
        });
        this.accessService.getCourseType().subscribe((x) => {
            this.courseTypes = x;
        });
        this.accessService.getTermType().subscribe((x) => {
            this.termTypes = x;
        });

        this.accessService.featureAccessible('Edit Course Histories').subscribe((x) => (this.editAccess = x));
        this.accessService.featureAccessible('Delete Course Histories').subscribe((x) => (this.deleteAccess = x));
        this.setStartingSchoolYearDate();
        this.getUserRegion();
    }
    ngOnChanges(): void {
        this.dataSource.data = JSON.parse(JSON.stringify(this.lstCourseHistory));
        this.dataSource.paginator = this.paginator;
    }
    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
    }

    editRow(row: EditableCourseHistory) {
        if (this.dataSource.data.findIndex((x) => x.isEdit == true) === -1) row.isEdit = true;
    }

    getUserRegion() {
        this.helperService.lstUserProfileRegion$.subscribe((userRegion: Region[]) => {
            this.userRegion = userRegion[0];
        });
    }

    removeCourseHistory(row: EditableCourseHistory) {
        if (this.dataSource.data.findIndex((x) => x.isEdit == true) === -1) {
            row.isEdit = true;
            row.isDelete = true;
        }
    }

    updateRow(row: EditableCourseHistory) {
        if (row.courseHistory.ID < 0) {
            //new CommunicationEventID

            this.createCourseHistory(row);
        } else {
            /*if (this.lstEditSCommunicationEventId.indexOf(row.studentCommunicationEvent.ID) == -1)
				this.lstEditSCommunicationEventId.push(row.studentCommunicationEvent.ID!);*/
            this.updateCourseHistoryService(row);
        }
    }

    deleteRow(row: EditableCourseHistory) {
        this.isSaving = true;

        this.courseHistoryService.deleteCourseHistory({ courseHistoryID: row.courseHistory.ID }).subscribe((x) => {
            this.isSaving = false;

            let msg: Msg = x['msg'];
            if (msg.SUCCESS) {
                this.statusReset('Successfully deleted Course History...');
                this.modificationEvent.emit('deleted');
            }
        });
    }
    cancelRow(row: EditableCourseHistory) {
        //revert back to original state
        //get the original data from PhoneData and update the row else remove the data.
        let courseHistoryEvent = this.lstCourseHistory.find((x) => x.courseHistory.ID === row.courseHistory.ID);
        if (courseHistoryEvent != undefined && courseHistoryEvent.courseHistory.ID! > 0) {
            row.courseHistory = JSON.parse(JSON.stringify(courseHistoryEvent.courseHistory));
            row.isEdit = false;
            row.isDelete = false;

            /*let itemIndex = this.lstEditSCommunicationEventId.indexOf(row.studentCommunicationEvent.ID);
			this.lstEditSCommunicationEventId = (itemIndex >= 0) ? this.lstEditSCommunicationEventId.filter((e, i) => i !== itemIndex) : this.lstEditSCommunicationEventId;*/
        } else {
            //this.dataSource.data = this.dataSource.data.filter((u: EditableStudentCommunicationEvent) => u.studentCommunicationEvent.ID !== row.studentCommunicationEvent.ID);
            this.modificationEvent.emit('cancelled');
        }
    }

    createCourseHistory(row: EditableCourseHistory) {
        this.isSaving = true;
        this.courseHistoryService.createCourseHistory({ courseHistory: row.courseHistory }).subscribe((x) => {
            row.isEdit = false;
            row.isDelete = false;
            this.isSaving = false;

            let msg: Msg = x['msg'];
            if (msg.SUCCESS) {
                this.statusReset('Successfully updated Course History...');
                this.modificationEvent.emit('created');
            }
        });
    }
    updateCourseHistoryService(row: EditableCourseHistory) {
        this.isSaving = true;
        this.courseHistoryService.updateCourseHistory({ courseHistory: row.courseHistory }).subscribe((x) => {
            row.isEdit = false;
            row.isDelete = false;
            this.isSaving = false;

            let msg: Msg = x['msg'];
            if (msg.SUCCESS) {
                this.statusReset('Successfully updated Course History...');
                this.modificationEvent.emit('modified');
            }
        });
    }

    performancePeriodEvent(performanceYear: string, row: EditableCourseHistory) {
        //Avoid calling duplicate API calls for the same input
        if (this.schoolYear != performanceYear) {
            this.schoolYear = performanceYear;
            row.courseHistory.SCHOOL_ENROLLMENT = new CourseHistorySchoolEnrollments();
            row.courseHistory.SCHOOL_YEAR = performanceYear;
            this.getSchoolEnrollments(this.schoolYear);
        }
    }

    disableSubmit(row: EditableCourseHistory) {
        let courseHistory: CourseHistory = row.courseHistory;

        if (row.courseHistory.ID < 0) {
            if (
                row.courseHistory.SCHOOL_YEAR == '' ||
                this.ctrEnrollment.invalid ||
                this.ctrCourseTitle.invalid ||
                this.ctrSubjectAreaName.invalid ||
                this.ctrCourseType.invalid ||
                this.ctrTermType.invalid ||
                this.ctrDaysCompleted.invalid ||
                this.ctrGradetoDate.invalid ||
                this.ctrCreditsGranted.invalid
            ) {
                return true;
            } else {
                return false;
            }
        } else {
            if (
                this.ctrCourseTitle.invalid ||
                this.ctrSubjectAreaName.invalid ||
                this.ctrCourseType.invalid ||
                this.ctrTermType.invalid ||
                this.ctrDaysCompleted.invalid ||
                this.ctrGradetoDate.invalid ||
                this.ctrCreditsGranted.invalid
            ) {
                return true;
            } else {
                return false;
            }
        }
    }

    matSelectEventchanged(element: EditableCourseHistory) {
        element.courseHistory.SCHOOL_ENROLLMENT = new CourseHistorySchoolEnrollments();
        this.getSchoolEnrollments(element.courseHistory.SCHOOL_YEAR);
    }
    compareFn(o1: any, o2: any) {
        if (!o1 || !o2) {
            return false;
        }
        return o1?.ID === o2?.ID;
    }

    statusReset(msg: string) {
        this.msgBar.open(msg, '', {
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
            duration: 3000
        });
    }

    getSchoolEnrollments(schoolYear: string) {
        this.courseHistoryService.getCourseHistorySchoolEnrollments({ studentId: this.studentId, schoolYear: schoolYear }).subscribe((x) => {
            if (x['msg'] !== undefined) {
                let msg: Msg = x['msg'];
                if (msg.SUCCESS == false) {
                    this.schoolenrollment = [];
                }
            } else {
                this.schoolenrollment = JSON.parse(x['schoolEnrollments']);
            }
        });
    }

    setStartingSchoolYearDate() {
        // Set the cut-off day to go to next school year (the week after the 3rd Friday in Sept)
        let mDate = moment({ month: 8, day: 1 }); // month is 0 based

        // By default we will need to add two weeks to the first friday
        let nWeeks = 2;
        let month = mDate.month();

        // Get first Friday of the first week of the month
        mDate = mDate.date(1).day(5);
        console;

        // Check if first Friday is in the given month
        //  it may have gone to the previous month
        if (mDate.month() != month) {
            nWeeks++;
        }

        this.startingSchoolYearDate = mDate.add(nWeeks, 'weeks').add(3, 'days').toDate();
    }
}

export const CourseHistoryColumns = [
    { key: 'isEdit', type: 'boolean', label: '' },
    { key: 'schoolYear', type: 'date', label: 'School Year' },
    { key: 'courseTitle', type: 'text', label: 'Course Title' },
    { key: 'subjectAreaName', type: 'date', label: 'Subject Area Name' },
    { key: 'courseType', type: 'text', label: 'Course Type' },
    { key: 'courseDuration', type: 'text', label: 'Course Duration' },
    { key: 'termType', type: 'text', label: 'Term Type' },
    { key: 'daysCompleted', type: 'boolean', label: 'Days Completed' },
    { key: 'gradetoDate', type: 'boolean', label: 'Grade-to-Date' },
    { key: 'creditsGranted', type: 'boolean', label: 'Credits Granted' },
    { key: 'addedByDate', type: 'boolean', label: 'Added By / Date' }
];
